import { SET_FILTER } from "../actions/filter";
import { SetFilterAction, FilterState } from "../types";

export const filter = (
  state: FilterState,
  action: SetFilterAction,
): FilterState => {
  switch (action.type) {
    case SET_FILTER:
      return action.value;

    default:
      return state;
  }
};
